import React, {Component} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';
import BetBothCard from './betBothCard';

class WinDrawWin extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        let storeData = store.getState();
        let useBetBothFootball = storeData.vpp.useBetBothFootball;

        return (<div className={marketStyle.marketGroup}>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[0]}/>
                <OddsCard store={store} market={markets[1]}/>
                <OddsCard store={store} market={markets[2]}/>
                <OddsCard store={store} market={markets[3]}/>
                <OddsCard store={store} market={markets[4]}/>
                <OddsCard store={store} market={markets[5]}/>
            </div>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[6]}/>
                <OddsCard store={store} market={markets[7]}/>
                <OddsCard store={store} market={markets[8]}/>
                <OddsCard store={store} market={'empty'}/>
                {useBetBothFootball.toLowerCase().includes('all') || useBetBothFootball.includes('3_1') ?
                    <BetBothCard store={store} markets={[markets[4], markets[13]]} id = 'Bet_both_1'/> :
                    <OddsCard store={store} market={'empty'}/>}
                {useBetBothFootball.toLowerCase().includes('all') || useBetBothFootball.includes('4_0') ?
                    <BetBothCard store={store} markets={[markets[5], markets[14]]} id = 'Bet_both_2'/> :
                    <OddsCard store={store} market={'empty'}/>}
            </div>
            <div className={marketStyle.scoreGroup}>
                <OddsCard store={store} market={markets[9]}/>
                <OddsCard store={store} market={markets[10]}/>
                <OddsCard store={store} market={markets[11]}/>
                <OddsCard store={store} market={markets[12]}/>
                <OddsCard store={store} market={markets[13]}/>
                <OddsCard store={store} market={markets[14]}/>
            </div>
        </div>);
    }
}

export default WinDrawWin;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/correctScore.js